import { useLocalStorage } from "usehooks-ts"

import { LOCAL_STORAGE_KEYS } from "~config/constants"
import useExpiration from "~utils/use-expiration"

// We create a new guest user every time you go through checkout, which will overwrite the existing one,
export default function usePersistedGuestAccessToken() {
    const [guestTokenInfo, setGuestTokenInfo] =
        useLocalStorage<PersistedGuestAccessToken | null>(
            LOCAL_STORAGE_KEYS.GUEST_TOKEN_INFO,
            null
        )

    const guestAccessToken = guestTokenInfo?.accessToken ?? null
    const createdAt = guestTokenInfo?.createdAt ?? null

    useExpiration({ createdAt, onIsExpired: () => setGuestTokenInfo(null) })

    return { guestAccessToken, setGuestTokenInfo }
}

interface PersistedGuestAccessToken {
    accessToken: string
    createdAt: number
}
